<template>
  <div class="case-evidence-form">
    <Form
      ref="formData" :key="formData.info.evidType"
      :model="formData" :rules="ruleValidate"
      :label-width="100"
    >
      <FormItem label="证据分类" prop="info.evidType">
        <Select v-model="formData.info.evidType" placeholder="请选择证据分类">
          <Option
            v-for="item in evidTypeArr" :key="item.id"
            :value="item.value"
          >{{ item.nameZh }}</Option>
        </Select>
      </FormItem>
      <FormItem
        v-if="formData.info.evidType=='EC'"
        label="固证工具"
        prop="infoAddition.curingToolType"
        :rules="[{required: true, message: '固证工具不能为空', trigger: 'change'}]"
      >
        <Select v-model="formData.infoAddition.curingToolType" placeholder="请选择固证工具">
          <Option
            v-for="item in selectCuringToolArr" :key="item.id"
            :value="item.value"
          >{{ item.nameZh }}</Option>
        </Select>
      </FormItem>
      <FormItem
        v-if="formData.info.evidType==='EC'"
        label="证据编号"
        prop="infoAddition.notarialCode"
        :rules="[{ max:128,message:'不能超过128个字符',trigger:'blur'}]"
      >
        <Input v-model="formData.infoAddition.notarialCode" placeholder="请输入证据编号" />
      </FormItem>
      <template v-if="formData.info.evidType!=='EC'">
        <FormItem
          label="公证书号"
          prop="infoAddition.notarialCode"
          :rules="[
            {required: true, message: '公证书号不能为空', trigger: 'change'},
            { max:128,message:'不能超过128个字符',trigger:'change'},
            {pattern: /^[\(（]\d{4}[\)\）][\S\u4e00-\u9fa5]+第\d+号$/, message: '请输入正确的公证书号', trigger: 'change'}
          ]"
        >
          <Poptip trigger="hover" placement="top-start">
            <custom-select
              key="notarialCode"
              placeholder="请输入或选择公证书号"
              :selected="formData.infoAddition.notarialCode"
              :option-list="notaryNumberList"
              @selectedItem="getSelectedItem($event,'notarialCode')"
            />
            <div slot="content">格式：（年份）xxx第xxx号</div>
          </Poptip>
        </FormItem>
        <FormItem
          label="公证机构"
          prop="infoAddition.notarialOffice"
        >
          <custom-select
            key="notarialOffice"
            :selected="formData.infoAddition.notarialOffice"
            placeholder="请输入或选择公证机构"
            :option-list="notarialOfficeList"
            @selectedItem="getSelectedItem($event,'notarialOffice')"
          />
        </FormItem>
      </template>
      <FormItem
        v-if="formData.info.evidType=='EC'"
        label="固证时间"
        prop="infoAddition.curingTime"
        :rules="[{required: true, message: '固证时间不能为空', trigger: 'blur'}]"
      >
        <DatePicker
          type="date" placeholder="请选择固证时间"
          style="width:100%" format="yyyy-MM-dd"
          :value="formData.infoAddition.curingTime" placement="bottom-start"
          @on-change="getValue($event,'infoAddition.curingTime')"
        />
      </FormItem>
      <FormItem
        v-if="formData.info.evidType!='EC'"
        label="落款时间"
        prop="infoAddition.notarialObtainDate"
      >
        <DatePicker
          type="date" placeholder="请选择落款时间"
          style="width:100%" format="yyyy-MM-dd"
          :value="formData.infoAddition.notarialObtainDate" placement="bottom-start"
          @on-change="getValue($event,'infoAddition.notarialObtainDate')"
        />
      </FormItem>
      <FormItem label="侵权产品数量" prop="infoAddition.productNum">
        <Input v-model="formData.infoAddition.productNum" placeholder="请输入侵权产品数量(数字)" />
      </FormItem>
      <FormItem
        v-if="clueDetail.tortType && clueDetail.tortType.indexOf('E')>-1"
        label="单价"
        prop="infoAddition.productPrice"
        :rules="[{required: true, message: '单价不能为空', trigger: 'blur'}]"
      >
        <my-input
          placeholder="请输入单价"
          :default-data="formData.infoAddition.productPrice"
          append-text="￥"
          :to-fixed="2"
          @getValue="getValue($event,'infoAddition.productPrice')"
        />
      </FormItem>
      <FormItem
        v-if="clueDetail.tortType && clueDetail.tortType.indexOf('E')>-1"
        label="销量"
        prop="infoAddition.productSaleNum"
        :rules="[{required: true, message: '销量不能为空', trigger: 'blur'},{pattern: /^[1-9]?\d{1,15}$/, message: '请输入正确的数字(最大不超过16位数)', trigger: 'blur'}]"
      >
        <Input v-model="formData.infoAddition.productSaleNum" placeholder="请输入销量(数字)" />
      </FormItem>
      <FormItem
        v-if="clueDetail.tortType && clueDetail.tortType.indexOf('E')>-1 && clueDetail.channelType=='PD'"
        label="评论数"
        prop="infoAddition.productComment"
        :rules="[{required: true, message: '评论数不能为空', trigger: 'blur'},{pattern: /^[1-9]?\d{1,15}$/, message: '请输入正确的数字(最大不超过16位数)', trigger: 'blur'}]"
      >
        <Input v-model="formData.infoAddition.productComment" placeholder="请输入评论数(数字)" />
      </FormItem>
      <FormItem label="取证时间" prop="info.evidDate">
        <DatePicker
          type="date" placeholder="请选择取证时间"
          style="width:100%" format="yyyy-MM-dd"
          :value="formData.info.evidDate" placement="bottom-start"
          @on-change="getValue($event,'info.evidDate')"
        />
      </FormItem>
      <FormItem label="取证地点" prop="info.evidAddress">
        <Input v-model="formData.info.evidAddress" placeholder="请输入取证地点" />
      </FormItem>
      <FormItem
        :label="formData.info.evidType=='EC'?'取证费':'公证费'"
        prop="info.notarialFees"
      >
        <my-input
          :placeholder="'请输入'+(formData.info.evidType=='EC'?'取证费':'公证费')"
          :default-data="formData.info.notarialFees"
          append-text="￥"
          :to-fixed="2"
          @getValue="getValue($event,'info.notarialFees')"
        />
      </FormItem>
      <FormItem
        :label="formData.info.evidType=='EC'?'取证费发票':'公证费发票'"
        prop="notarialFeeAttachments"
      >
        <file-upload
          v-if="isDetailLoad"
          :default-list="notarialFeeDefaultList || []"
          :upload-config="{maxNum:1}"
          @getFileList="getAttachmentList($event,'notarialFeeAttachments')"
        />
      </FormItem>
      <FormItem label="购物费" prop="info.shoppingFees">
        <my-input
          placeholder="请输入购物费"
          :default-data="formData.info.shoppingFees"
          append-text="￥"
          :to-fixed="2"
          @getValue="getValue($event,'info.shoppingFees')"
        />
      </FormItem>
      <FormItem label="购物费发票" prop="shoppingFeeAttachments">
        <file-upload
          v-if="isDetailLoad"
          :default-list="shoppingFeeDefaultList || []"
          :upload-config="{}"
          @getFileList="getAttachmentList($event,'shoppingFeeAttachments')"
        />
      </FormItem>
      <FormItem label="其它费用" prop="info.otherFees">
        <my-input
          placeholder="请输入其它费用"
          :default-data="formData.info.otherFees"
          append-text="￥"
          :to-fixed="2"
          @getValue="getValue($event,'info.otherFees')"
        />
      </FormItem>
      <FormItem label="公证书附件" prop="notarialDeedAttachments">
        <file-upload
          v-if="isDetailLoad" :key="'notarialDeedDefaultList'"
          :default-list="notarialDeedDefaultList || []"
          :upload-config="{maxNum:1}"
          @getFileList="getAttachmentList($event,'notarialDeedAttachments')"
        />
      </FormItem>
      <FormItem label="主体披露附件">
        <file-upload
          v-if="isDetailLoad"
          :default-list="evidDefaultList || []"
          :upload-config="{}"
          @getFileList="getAttachmentList($event,'evidAttachments')"
        />
      </FormItem>
    </Form>
    <Row class="detail-btn-box">
      <Button
        type="primary" style="margin-right:10px;"
        :disabled="isSubmit" @click="validCheck"
      >保存</Button>
      <Button @click="$emit('changeEditCtrl',false)">取消</Button>
    </Row>

    <Modal
      v-model="confirmCtrl"
      title="提示信息"
      :width="360"
      :footer-hide="true"
    >
      <Row v-if="!defaultData.id" class="modal-tips">已存在同本公证书，请确认公证书号/证据编号是否录入错误，如确认无误该证据将关联到本案</Row>
      <Row v-else class="modal-tips">已存在同本公证书，当前证据将被删除，同时会将证据关联到本案件</Row>
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button
          type="primary" :disabled="isLoading"
          :loading="isLoading" @click="confirmSubmit"
        >确认</Button>
        <Button style="margin-left: 8px" @click="confirmCtrl=false;">取消</Button>
      </Row>
    </Modal>
  </div>
</template>
<script>
import myInput from '@/components/common/myInput/myInput.vue'
import CustomSelect from '@/components/common/customSelect/customSelect.vue'
export default {
  components: {
    CustomSelect,
    myInput
  },
  props: {
    defaultData: {
      type: Object | String
    },
    clueDetail: {
      type: Object | String
    }
  },
  data () {
    return {
      isSubmit: false,
      evidTypeArr: [],
      selectCuringToolArr: [],
      evidDefaultList: [],
      notarialDeedDefaultList: [],
      notarialFeeDefaultList: [],
      shoppingFeeDefaultList: [],
      evidenceArr: [
        {
          nameZh: '公证',
          value: 'GZ'
        },
        {
          nameZh: '电子固证',
          value: 'DZGZ'
        }
      ],
      formData: {
        caseId: '',
        info: {
          evidType: '',
          evidDate: '',
          notarialFees: '',
          shoppingFees: '',
          otherFees: '',
          evidAddress: ''
        },
        infoAddition: {
          curingToolType: '',
          notarialCode: '',
          notarialOffice: '',
          notarialObtainDate: '',
          curingTime: '',
          productNum: 1,
          productPrice: '',
          productSaleNum: '',
          productComment: ''
        },
        evidAttachments: [],
        notarialDeedAttachments: [],
        notarialFeeAttachments: [],
        shoppingFeeAttachments: []
      },
      ruleValidate: {
        'info.evidType': [{ required: true, message: '证据分类不能为空', trigger: 'change' }],
        'infoAddition.notarialOffice': [{ required: true, message: '公证机构不能为空', trigger: 'blur' }, { max: 32, message: '不能超过32个字符', trigger: 'blur' }],
        'infoAddition.notarialObtainDate': [{ required: true, message: '落款时间不能为空', trigger: 'blur' }],
        'infoAddition.productNum': [{ pattern: /^[1-5]$/, message: '请输入正确的数字(最大不超过5)', trigger: 'blur' }],
        'info.evidDate': [{ required: true, message: '取证时间不能为空', trigger: 'blur' }],
        'info.evidAddress': [{ max: 64, message: '不能超过64个字符', trigger: 'blur' }],
        'info.notarialFees': [{ required: true, message: '公证费不能为空', trigger: 'blur' }],
        'info.shoppingFees': [{ required: true, message: '购物费不能为空', trigger: 'blur' }],
        notarialDeedAttachments: [{ required: true, type: 'array', message: '公证书附件不能为空', trigger: 'blur' }]
        // evidAttachments:[{ required: true,type:"array", message: '公证物附件不能为空', trigger: 'blur' }]
      },
      isDetailLoad: false,
      confirmCtrl: false,
      isLoading: false,
      notaryNumberList: [],
      notarialOfficeList: [],
      model1: null
    }
  },
  watch: {
    formData: {
      handler(newVal) {
      },
      deep: true
    }
  },
  created() {
    this.notaryNumberList = JSON.parse(localStorage.getItem('cacheNotaryNumber')) || []
    this.notarialOfficeList = JSON.parse(localStorage.getItem('cacheNotarialOffice')) || []
  },
  beforeMount() {
    this.getDictionary()
    if (this.defaultData.id) {
      this.giveData()
      return
    }
    // 取证地址默认为线索的调查地址
    if (this.clueDetail) {
      this.formData.info.evidAddress = `${this.clueDetail.provinceName || ''}${this.clueDetail.cityName || ''}${this.clueDetail.areaName || ''}${this.clueDetail.address || ''}`
    }
    this.isDetailLoad = true
  },
  mounted() {
  },
  updated() {},
  methods: {
    getSelectedItem(val, key) {
      this.formData.infoAddition[key] = val || ''
      // 自定义的选择框，无法触发表单验证，需手动添加验证方法
      this.$refs.formData.validate()
    },
    // 添加公证书号历史本地缓存
    addNotaryNumber () {
      const val = this.formData.infoAddition.notarialCode
      const item = {
        value: val,
        label: val
      }
      !this.notaryNumberList.some(item => item.value === val) && this.notaryNumberList.unshift(item)
      this.notaryNumberList = this.notaryNumberList.slice(0, 10)
      localStorage.setItem('cacheNotaryNumber', JSON.stringify(this.notaryNumberList))
    },
    // 添加公证机构历史本地缓存
    addNotarialOffice () {
      const val = this.formData.infoAddition.notarialOffice
      const item = {
        value: val,
        label: val
      }
      !this.notarialOfficeList.some(item => item.value === val) && this.notarialOfficeList.unshift(item)
      this.notarialOfficeList = this.notarialOfficeList.slice(0, 10)
      localStorage.setItem('cacheNotarialOffice', JSON.stringify(this.notarialOfficeList))
    },
    getValue(data, key) {
      const arr = key.split('.')
      this.formData[arr[0]][arr[1]] = data
    },
    getAttachmentList(arr, key) {
      this.formData[key] = []

      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        if (item.id) { obj.id = item.id }
        this.formData[key].push(obj)
      })
      // 为上传组件重新赋值
      switch (key) {
        case 'notarialFeeAttachments':
          this.notarialFeeDefaultList = this.formData[key]
          break
        case 'shoppingFeeAttachments':
          this.shoppingFeeDefaultList = this.formData[key]
          break
        case 'notarialDeedAttachments':
          this.notarialDeedDefaultList = this.formData[key]
          break
        case 'evidAttachments':
          this.evidDefaultList = this.formData[key]
          break
        default:
          break
      }
    },
    // 对公证书号、公证机构进行本地缓存操作；
    addCacheData() {
      if (this.formData.info.evidType !== 'EC') {
        this.addNotaryNumber()
        this.addNotarialOffice()
      }
    },
    // 提交数据
    submitNew() {
      let url = '/business/evidence'
      this.formData.caseId = this.defaultData.caseId
      const ajaxData = this.formData
      if (this.defaultData.id) {
        url += `/${this.defaultData.id}`
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$patch(url, ajaxData).then(res => {
              this.submitFunc(res)
            })
          }
        })
      } else {
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$post(url, ajaxData).then(res => {
              this.submitFunc(res)
            })
          }
        })
      }
    },
    submitFunc(res) {
      this.isSubmit = false
      if (res.code == 0) {
        this.$Message.success('操作成功')
        // 提交完成后，对公证书号、公证机构进行本地缓存操作；
        this.addCacheData()
        this.$emit('changeEditCtrl', true)
      } else {
        this.$Message.error(res.message)
      }
    },
    validCheck() {
      if (this.formData.info.evidType == 'EC') {
        this.submitNew()
        return
      }
      if (!this.formData.infoAddition.notarialCode) {
        this.$refs.formData.validate()
        return
      }
      const url = '/business/evidence'
      const ajaxData = {
        notarialCode: this.formData.infoAddition.notarialCode
      }
      this.$get(url, ajaxData).then(res => {
        if (res.data) {
          if (this.defaultData && this.defaultData.caseId != res.data.caseId) {
            this.confirmCtrl = true
          } else {
            this.submitNew()
          }
        } else {
          this.submitNew()
        }
      })
    },
    confirmSubmit() {
      this.submitNew()
    },
    giveData() {
      this.formData.id = this.defaultData.id
      this.formData.evidInfoId = this.defaultData.evidInfoId
      this.formData.info = {
        evidType: this.defaultData.info.evidType,
        evidDate: this.defaultData.info.evidDate,
        notarialFees: this.defaultData.info.notarialFees,
        shoppingFees: this.defaultData.info.shoppingFees,
        otherFees: this.defaultData.info.otherFees,
        evidAddress: this.defaultData.info.evidAddress,
        id: this.defaultData.info.id
      }
      this.formData.infoAddition = {
        curingToolType: this.defaultData.infoAddition.curingToolType,
        notarialCode: this.defaultData.infoAddition.notarialCode,
        notarialOffice: this.defaultData.infoAddition.notarialOffice,
        notarialObtainDate: this.defaultData.infoAddition.notarialObtainDate,
        curingTime: this.defaultData.infoAddition.curingTime,
        productNum: this.defaultData.infoAddition.productNum,
        productPrice: this.defaultData.infoAddition.productPrice,
        productSaleNum: this.defaultData.infoAddition.productSaleNum + '',
        productComment: this.defaultData.infoAddition.productComment + '',
        id: this.defaultData.infoAddition.id,
        evidInfoId: this.defaultData.infoAddition.evidInfoId
      }
      this.formData.evidAttachments = this.defaultData.evidAttachments
      this.formData.notarialDeedAttachments = this.defaultData.notarialDeedAttachments
      this.formData.notarialFeeAttachments = this.defaultData.notarialFeeAttachments
      this.formData.shoppingFeeAttachments = this.defaultData.shoppingFeeAttachments

      this.evidDefaultList = this.defaultData.evidAttachments
      this.notarialDeedDefaultList = this.defaultData.notarialDeedAttachments
      this.notarialFeeDefaultList = this.defaultData.notarialFeeAttachments
      this.shoppingFeeDefaultList = this.defaultData.shoppingFeeAttachments

      this.isDetailLoad = true
    },
    // 数据字典
    async getDictionary() {
      this.evidTypeArr = await this.common.getDictionaryItems('evid_type')
      this.selectCuringToolArr = await this.common.getDictionaryItems('select_curing_tool')
    }
  }
}
</script>
<style lang="scss">
.case-evidence-form{
    .ivu-poptip,.ivu-poptip-rel{
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/case/caseEvidenceForm.vue